import { Reachability } from '@aws-amplify/core';
export var ReachabilityMonitor = new Reachability().networkMonitor();
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-amplify/datastore/lib-esm/sync/datastoreReachability/index.js
// module id = null
// module chunks = 